import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-new-report-widget-filter-settings-footer',
    templateUrl: './fi-new-report-widget-filter-settings-footer.component.html',
    styleUrls: ['./fi-new-report-widget-filter-settings-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-new-report-widget-filter-settings-footer' },
    standalone: false,
})
export class FiNewReportWidgetFilterSettingsFooterComponent {
    public isSaveButtonDisabled = input.required<boolean>();
    public closeDialog = output<void>();
    public saveWidget = output<void>();
}